import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {ToolsService} from '../../../services/tools.service';
import {StaffMember} from '../../../types/StaffMember';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {StaffMemberDetailsModal} from '../staff-member-details-modal/staff-member-details-modal.component';
import {AppConfigService} from '../../../services/app-config.service';
import {DeviceTypeEnum} from '../../../enums/DeviceTypeEnum';

@Component({
  selector: 'app-staff-member',
  templateUrl: './staff-member.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffMemberComponent {
  public staffMember = input<StaffMember>(null);
  public theme = input<string>(null);
  public imageSize = computed<number>(() => {
    switch (this.theme()) {
      case 'sm':
        return 48;
      case 'md':
        return 64;
      default:
        return 64;
    }
  });
  public imageClasses = computed<string>(() => {
    switch (this.theme()) {
      case 'sm':
        return 'min-w-12 max-w-full w-12 h-12';
      case 'md':
        return 'min-w-16 max-w-full w-16 h-16';
      default:
        return 'min-w-16 max-w-full w-16 h-16';
    }
  });

  public imgUrl = computed<string>(() =>
    this.staffMember() && !this.tools.isNil(this.staffMember().picture) && this.staffMember().picture !== ''
      ? `${this.appConfigService.appConfig.amazonS3Url}${this.staffMember().picture}`
      : `${this.appConfigService.appConfig.amazonS3Url}assets/default-avatar.svg`,
  );
  public hasDescription = computed<boolean>(() => !!(this.staffMember() && this.staffMember().description));

  constructor(
    private tools: ToolsService,
    private dialog: MatDialog,
    private appConfigService: AppConfigService,
  ) {}

  public openDetails() {
    if (!this.staffMember() || !this.staffMember().description) {
      return;
    }

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;

    if (this.tools.getDeviceType() === DeviceTypeEnum.DESKTOP) {
      dialogConfig.maxWidth = 560;
      dialogConfig.width = '100%';
      dialogConfig.minHeight = 400;
      dialogConfig.panelClass = 'staff-member-modal';
    } else if (this.tools.getDeviceType() === DeviceTypeEnum.MOBILE) {
      dialogConfig.width = '100%';
      dialogConfig.height = '100%';
      dialogConfig.maxWidth = '100vw';
      dialogConfig.maxHeight = '100vh';
      dialogConfig.panelClass = ['staff-member-modal', 'staff-member-modal-fullscreen'];
    }

    dialogConfig.data = this.staffMember();
    this.dialog.open(StaffMemberDetailsModal, dialogConfig);
  }
}
